import { instance } from "api/apiBase";

export type ApprovalLikelihoodBand = "low" | "medium" | "high";

export const APPROVAL_LIKELIHOOD_BANDS: ApprovalLikelihoodBand[] = [
  "low",
  "medium",
  "high"
];

export const APPROVAL_LIKELIHOOD_BAND_LABEL: Record<
  ApprovalLikelihoodBand,
  string
> = {
  low: "Low",
  medium: "Medium",
  high: "High"
};

export const isApprovalLikelihoodBand = (
  value: unknown
): value is ApprovalLikelihoodBand =>
  typeof value === "string" &&
  (APPROVAL_LIKELIHOOD_BANDS as string[]).includes(value);

export type ApprovalLikelihoodFactorKey =
  | "source"
  | "responsiveness"
  | "move_in"
  | "requirements"
  | "prescreening_match"
  | "income_to_rent_ratio"
  | "prescreening_borderline_criterion"
  | "showing_reliability"
  | "fraud_risk";

export interface ApprovalLikelihoodFactor {
  key: ApprovalLikelihoodFactorKey;
  data_available: boolean;
  rationale_text: string;
}

interface ApprovalLikelihoodRationale {
  approval_likelihood_band: ApprovalLikelihoodBand | null;
  factors: ApprovalLikelihoodFactor[];
}

export const APPROVAL_LIKELIHOOD_FACTOR_LABEL: Record<
  ApprovalLikelihoodFactorKey,
  string
> = {
  source: "Source",
  responsiveness: "Inbox message responsiveness & thoroughness",
  move_in: "Desired move-in date",
  requirements: "Number of requirements",
  prescreening_match: "Pre-screening criteria match",
  income_to_rent_ratio: "Income-to-rent ratio",
  prescreening_borderline_criterion: "Borderline/failing criterion",
  showing_reliability: "Showing reliability",
  fraud_risk: "Fraud risk on contact info"
};

export const getApprovalLikelihood = async (
  leadId: string | number
): Promise<ApprovalLikelihoodRationale> => {
  const { data } = await instance.get<ApprovalLikelihoodRationale>(
    `/portal/v1/leads/${leadId}/score`
  );
  return data;
};
